import React from 'react';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
interface TestimonialCardProps {
  name: string;
  location: string;
  quote: string;
  image?: string;
}
export const TestimonialCard: React.FC<TestimonialCardProps> = ({
  name,
  location,
  quote
}) => {
  return <motion.div whileHover={{
    y: -4
  }} transition={{
    duration: 0.3
  }} className="bg-white p-8 rounded-2xl shadow-lg border border-blue-100 flex flex-col h-full hover:shadow-xl transition-shadow relative overflow-hidden" data-id="element-23">
      {/* Decorative quote icon */}
      <div className="absolute top-4 right-4 opacity-5" data-id="element-24">
        <Quote className="w-16 h-16 text-blue-600" data-id="element-25" />
      </div>

      <div className="flex gap-1 mb-5 relative z-10" data-id="element-26">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-27" />)}
      </div>

      <p className="text-gray-700 text-lg leading-relaxed mb-6 flex-grow relative z-10 italic" data-id="element-28">
        "{quote}"
      </p>

      <div className="mt-auto border-t border-gray-100 pt-5 relative z-10" data-id="element-29">
        <p className="font-bold text-gray-900 text-lg" data-id="element-30">{name}</p>
        <p className="text-sm text-gray-500 mt-1" data-id="element-31">{location}</p>
      </div>
    </motion.div>;
};